// <head> лендинга «Учёба за рубежом»: мета на языке страницы, canonical,
// hreflang на три адреса, og, шрифты и стили.
import abroadCss from "./abroad.css?url";
import { ABROAD_COPY, ABROAD_PATH } from "./abroad-copy";
import type { SiteLang } from "@/components/site/SiteChrome";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
import { withCountriesNom } from "@/edu/countries-count";
import { OG_LOCALE, socialMeta } from "@/lib/page-meta";

const SITE = "https://yolutap.com";
const OG_IMAGE = `${SITE}/photos/home/gen-family-kitchen-1264.webp`;

/** JSON-LD FAQPage — ровно те вопросы и ответы, что раскрываются на странице (ABROAD_COPY[lang].faq). */
export function abroadFaqJsonLd(lang: SiteLang, countries: number | null = null) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    inLanguage: lang,
    mainEntity: ABROAD_COPY[lang].faq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: withCountriesNom(f.a, lang, countries) },
    })),
  };
}

export function abroadHead(lang: SiteLang, countries: number | null = null) {
  const url = SITE + ABROAD_PATH[lang];
  return {
    meta: [
      ...socialMeta(ABROAD_COPY[lang].meta),
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: OG_LOCALE[lang] },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "ru", href: SITE + ABROAD_PATH.ru },
      { rel: "alternate", hrefLang: "az", href: SITE + ABROAD_PATH.az },
      { rel: "alternate", hrefLang: "en", href: SITE + ABROAD_PATH.en },
      // x-default — азербайджанская версия (27.10.2026, решение владельца: x-default везде = /az).
      { rel: "alternate", hrefLang: "x-default", href: SITE + ABROAD_PATH.az },
      ...SITE_CHROME_LINKS,
      { rel: "stylesheet", href: abroadCss },
    ],
    // «<» экранируется: текст ответа не должен суметь закрыть тег <script>.
    scripts: [{ type: "application/ld+json", children: JSON.stringify(abroadFaqJsonLd(lang, countries)).replace(/</g, "\\u003c") }],
  };
}
